import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TextField } from '@mui/material';

import { MultiSelect } from 'components/shared';
import { GridCompact12 } from 'components/shared/Grid/Grid.components';

interface Option {
  id?: number | string;
  name?: string;
}

interface ControlledMultiSelectProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  options: Option[];
  label: string;
  loading?: boolean;
  optionLabelProp?: string;
  idProperty?: string;
}

export const ControlledMultiSelect = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  loading = false,
  optionLabelProp = 'name',
  idProperty = 'id'
}: ControlledMultiSelectProps<T>) => {
  const { t } = useTranslation();

  return (
    <GridCompact12>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <MultiSelect
            {...field}
            onChange={(selectedOptions) => {
              field.onChange(selectedOptions);
            }}
            options={options}
            idProperty={idProperty}
            optionLabelProp={optionLabelProp}
            selectedOptions={field.value || []}
            renderTags={(e) => `${e.length} ${t('selected').toLowerCase()}`}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                size="small"
                variant="outlined"
              />
            )}
            loading={loading}
          />
        )}
      />
    </GridCompact12>
  );
};
